/*
 * ----------------
 * Branding
 * ----------------
 */
export var oxfordBlue = {
    100: '#031E45',
    80: '#354B6A',
    60: '#68788F',
    40: '#9AA5B5',
    20: '#CDD2DA',
};
export var seafoam = {
    100: '#47BFAF',
    80: '#6CCCBF',
    60: '#91D9CF',
    40: '#B5E5DF',
    20: '#DAF2EF',
};
/*
 * ----------------
 * Record
 * ----------------
 */
export var dash = {
    900: '#987803',
    800: '#BE9503',
    700: '#E4B304',
    600: '#FBC913',
    500: '#FCD442',
    400: '#FDDF71',
    300: '#FDE489',
    200: '#FDE9A1',
    100: '#FEF4D0',
    50: '#FFFAE7',
};
export var contact = {
    900: '#004F82',
    800: '#006DA1',
    700: '#007EB4',
    600: '#0090C7',
    500: '#009ED4',
    400: '#23AAD9',
    300: '#4BBADD',
    200: '#7CCDE7',
    100: '#AFE1F0',
    50: '#E0F3F9',
};
export var patient = {
    900: '#1F256A',
    800: '#303077',
    700: '#3A367F',
    600: '#453E88',
    500: '#4D438E',
    400: '#675D97',
    300: '#8B80C0',
    200: '#A39EC1',
    100: '#C7C4DA',
    50: '#E9E7F0',
};
export var clinical = {
    900: '#336D15',
    800: '#578F27',
    700: '#6BA330',
    600: '#80B73A',
    500: '#8FC742',
    400: '#A0D05F',
    300: '#B2D87D',
    200: '#C8E3A3',
    100: '#DEEEC7',
    50: '#F2F9E8',
};
export var financial = {
    900: '#845108',
    800: '#D3810D',
    700: '#F29E25',
    600: '#F5B151',
    500: '#F6BB66',
    400: '#F7C57C',
    300: '#F9CF92',
    200: '#FAD8A8',
    100: '#FCECD3',
    50: '#FEF5E9',
};
export var report = {
    900: '#174938',
    800: '#216452',
    700: '#27745F',
    600: '#2C846E',
    500: '#30917A',
    400: '#41A18C',
    300: '#5CB29F',
    200: '#87C8BA',
    100: '#B5DDD5',
    50: '#E1F1EE',
};
export var admin = {
    900: '#C30017',
    800: '#D20024',
    700: '#E0072B',
    600: '#F21B31',
    500: '#FF2931',
    400: '#FD414C',
    300: '#F16A70',
    200: '#F89599',
    100: '#FFCBD2',
    50: '#FFEAEE',
};
export var help = {
    900: '#2A4689',
    800: '#3562A9',
    700: '#3C73BB',
    600: '#4484CE',
    500: '#4B92DB',
    400: '#5CA1E1',
    300: '#74B1E5',
    200: '#98C7EE',
    100: '#BFDCF4',
    50: '#E4F1FA',
};
export var boarding = {
    400: '#C59445',
    300: '#D1AB6D',
    200: '#E1C9A1',
    100: '#EEE0C9',
    50: '#F6F0E4',
};
export var documents = {
    400: '#ACF3FD',
    200: '#BCFFFF',
    100: '#C5FFFF',
    50: '#D5FFFF',
};
//# sourceMappingURL=primitives.js.map